import './NotificationsPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import clone from 'clone';
import InfiniteScroll from 'react-infinite-scroller';

import { cancelNotification, getNotifications, getScheduledNotifications, postNotification, setNotification } from './store/actions';
import { getAds } from "../AdsPage/store/actions";
import { getNewsStories } from "../News/store/actions";

import ConfirmModal from 'components/Modal/ConfirmModal';
import NotificationsForm from './NotificationsForm';
import PageContent from 'components/PageContent';
import moment from "moment/moment";
import Button from "../../components/Button";
import FormRow from "../../components/FormRow";
import LoadingCircle from "../../components/LoadingCircle";

class NotificationsPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showConfirmModal: false,
            showDeleteConfirmModal: false,
            confirmModalText: 'Notification sent!',
            notificationToCancel: null,
            notificationType: null,
            atEnd: true,
            isInfiniteScrolling: false
        };
    }

    componentWillMount() {
        document.body.classList.add('notifications-page');

        this.props.getNotifications()
            .then((res) => {
                this.setState({atEnd: res.data.length === 0});
            });
        this.props.getScheduledNotifications();
        this.props.getAds();
        this.props.getNewsStories();
    }

    componentWillUnmount() {
        document.body.classList.remove('notifications-page');
    }

    editScheduledNotification = (notification) => {
        this.props.setNotification(clone(notification));
        this.setState({notificationType: notification.metadata.type});
    };

    handleDelete() {
        this.props.cancelNotification(this.state.notificationToCancel.id)
            .then((res) => {
                this.setState({
                    notificationToCancel: null,
                    showDeleteConfirmModal: false
                });
                this.props.getScheduledNotifications();
            })
            .catch((err) => {
                console.log('NotificationsPage handleDelete err', err);
            });
    };

    async handleInfiniteScroll() {
        if(this.props.notifications.isGettingNewsStories || this.state.isInfiniteScrolling || this.state.atEnd) {
            return;
        }

        try {
            this.setState({isInfiniteScrolling: true});
            let res = await this.props.getNotifications(true);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: res.data.length === 0
            });
        } catch(err) {
            console.log('NotificationsPage handleInfiniteScroll err', err);
            this.setState({
                isInfiniteScrolling: false,
                atEnd: true
            });
        }
    };

    handleSubmit(notificationType) {
        this.setState({confirmModalText: this.props.notifications.notification.sendAt ? 'Notification Scheduled!' : 'Notification Sent!'});
        this.props.postNotification(notificationType)
            .then((res) => {
                this.setState({showConfirmModal: true});
                this.props.getNotifications();
                this.props.getScheduledNotifications();
                this.formRef.setNotificationType(null);
            });
    }

    render() {
        this.columns = [
            {
                text: 'Send Date',
                name: 'sentDate'
            }, {
                text: 'Title',
                name: 'title'
            }, {
                text: 'Body',
                name: 'body'
            }, {
                text: 'News URL',
                name: 'url'
            }, {
                text: 'Ad ID',
                name: 'adCampaignId'
            }, {
                text: 'Users Targeted',
                name: 'numUsersTargeted'
            }, {
                text: 'Available',
                name: 'numUsersAvailable'
            }, {
                text: 'Delivered',
                name: 'numUsersDelivered'
            }
        ];

        this.scheduledColumns = [
            {
                text: 'Send Date and Time',
                name: 'sendAt'
            }, {
                text: 'Title',
                name: 'title'
            }, {
                text: 'Body',
                name: 'body'
            }, {
                text: 'News URL',
                name: 'url'
            }, {
                text: 'Actions',
                name: 'actions'
            }
        ];

        return (
            <PageContent>
                <InfiniteScroll
                    pageStart={0}
                    loadMore={this.handleInfiniteScroll.bind(this)}
                    hasMore={!this.state.atEnd}
                >
                    <div className="notifications">
                        <NotificationsForm
                            ads={this.props.ads.all}
                            error={this.props.notifications.error}
                            handleSubmit={this.handleSubmit.bind(this)}
                            isSending={this.props.notifications.isSending}
                            newsStories={this.props.news.stories}
                            notification={this.props.notifications.notification}
                            notificationType={this.state.notificationType}
                            ref={instance => { this.formRef = instance; }}
                            setNotification={this.props.setNotification.bind(this)}
                            setNotificationType={(type) => this.setState({notificationType: type})}
                        />

                        <h2>
                            Scheduled Notifications
                        </h2>

                        <div className="notifications-table--wrapper">
                            <table className="notifications-table">
                                <thead>
                                <tr>
                                    {this.scheduledColumns.map((col, index) => {
                                        return (
                                            <th className="notifications-table__heading"
                                                key={index}>
                                                {col.text}
                                            </th>
                                        )
                                    })}
                                </tr>
                                </thead>
                                <tbody>
                                {this.props.notifications.scheduled.map((notification) => {
                                    return (
                                        <tr key={notification.id}>
                                            {this.scheduledColumns.map((col, index) => {
                                                if(col.name === 'sendAt') {
                                                    return (
                                                        <td key={index}>
                                                            {moment(notification.sendAt).format('M/D/YY [at] h:mma')}
                                                        </td>
                                                    );
                                                } else if(col.name === 'url') {
                                                    return (
                                                        <td key={index}>
                                                            <div style={{maxWidth: 200}}>
                                                                {notification.metadata ? (notification.metadata.url || notification.metadata.viewUrl) : ''}
                                                            </div>
                                                        </td>
                                                    );
                                                } else if(col.name === 'actions') {
                                                    return (
                                                        <td key={index} className="notifications-table__actions">
                                                            <Button noStyles
                                                                    onClick={() => this.editScheduledNotification(notification)}
                                                                    type="button">
                                                                Edit <img src="/img/icon--pencil.svg" alt="Edit" />
                                                            </Button>

                                                            <Button noStyles
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            notificationToCancel: notification,
                                                                            showDeleteConfirmModal: true
                                                                        });
                                                                    }}
                                                                    type="button">
                                                                Cancel <img src="/img/icon--delete.svg" alt="Delete" />
                                                            </Button>
                                                        </td>
                                                    )
                                                } else {
                                                    return (
                                                        <td key={index}>
                                                            {notification[col.name]}
                                                        </td>
                                                    );
                                                }
                                            })}
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        </div>

                        <h2>
                            Past Notifications
                        </h2>

                        <div className="notifications-table--wrapper">
                            <table className="notifications-table">
                                <thead>
                                    <tr>
                                        {this.columns.map((col, index) => {
                                            return (
                                                <th className="notifications-table__heading"
                                                    key={index}>
                                                    {col.text}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.notifications.all.map((notification) => {
                                        return (
                                            <tr key={notification.id}>
                                                {this.columns.map((col, index) => {
                                                    if(col.name === 'sentDate') {
                                                        return (
                                                            <td key={index}>
                                                                {moment(notification.sentDate).format('M/D/YY')}
                                                            </td>
                                                        );
                                                    } else if(col.name === 'url') {
                                                        return (
                                                            <td key={index}>
                                                                <div style={{maxWidth: 200}}>
                                                                    {notification.metadata ? notification.metadata.url : ''}
                                                                </div>
                                                            </td>
                                                        );
                                                    } else {
                                                        return (
                                                            <td key={index}>
                                                                {notification[col.name]}
                                                            </td>
                                                        );
                                                    }
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>

                            {this.state.isInfiniteScrolling && (
                                <div className="notifications__infinite-scroll-spinner">
                                    <LoadingCircle />
                                </div>
                            )}
                        </div>
                    </div>
                </InfiniteScroll>

                <ConfirmModal
                    confirmOnClick={() => this.setState({showConfirmModal: false})}
                    confirmText="OK"
                    contentLabel="Modal confirming new notification"
                    show={this.state.showConfirmModal}
                    showDeclineButton={false}
                    title={this.state.confirmModalText}
                />

                <ConfirmModal
                    confirmOnClick={this.handleDelete.bind(this)}
                    confirmText="Delete"
                    content={(
                        <div style={{color: '#ffffff'}}>
                            {Object.keys(this.props.notifications.cancelNotificationError).length > 0 ? (
                                <FormRow>
                                    {this.props.notifications.cancelNotificationError.friendlyMessage || this.props.notifications.cancelNotificationError.message}
                                </FormRow>
                            ) : null}
                        </div>
                    )}
                    contentLabel="Modal confirming new notification"
                    declineOnClick={() => {
                        this.setState({
                            notificationToCancel: null,
                            showDeleteConfirmModal: false
                        });
                    }}
                    declineText="Cancel"
                    show={this.state.showDeleteConfirmModal}
                    showActivityIndicator={this.props.notifications.isCancelling}
                    title="Cancel Notification?"
                />
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ads: state.ads,
        news: state.news,
        notifications: state.notifications
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        cancelNotification: (id) => dispatch(cancelNotification(id)),
        getAds: () => dispatch(getAds()),
        getNewsStories: () => dispatch(getNewsStories()),
        getNotifications: (isUpdate) => dispatch(getNotifications(isUpdate)),
        getScheduledNotifications: () => dispatch(getScheduledNotifications()),
        postNotification: (notificationType) => dispatch(postNotification(notificationType)),
        setNotification: (notification) => dispatch(setNotification(notification))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsPage);



// WEBPACK FOOTER //
// ./src/containers/NotificationsPage/index.js